import { AlertDialog, AlertDialogContent, AlertDialogTitle, AlertDialogDescription, AlertDialogCancel, AlertDialogAction, AlertDialogHeader, AlertDialogFooter } from "@/modules/shared/ui/components/alert-dialog"
import { useNavigate } from "react-router-dom"

interface DebugAiCallDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
}


export function DebugAiCallDialog({
    open,
    onOpenChange,
}: DebugAiCallDialogProps) {
    const navigate = useNavigate();

    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent className="bg-card">
                <AlertDialogHeader>
                    <AlertDialogTitle>AI Call Agent Testing - Phone number required</AlertDialogTitle>
                    <AlertDialogDescription>
                        For testing purposes, a phone number is required to use AI calling. Please add one in your profile before continuing.
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel>Cancel</AlertDialogCancel>
                    <AlertDialogAction onClick={() => navigate("/account/profile")}>
                        Go to Profile
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}
